<template>
  <vue-scroll>
    <rabbey-toolbox :call-new="callNew" />

    <rabbey-table2
      index-url="/api/contacts"
      :actions="actions"
      :columns="columns"
      :default-params="params"
      @rtable-push-action="handlePushAction"
    />

    <contact-form
      ref="contact_form"
      :title="title"
      :drawer.sync="drawer"
      :is-view="isView"
      :is-edit="isEdit"
    />
  </vue-scroll>
</template>

<script>
import { formatDate } from "../../utils";
import ContactForm from "./ContactForm";

export default {
  name: "ContactList",
  components: {
    ContactForm
  },
  data() {
    return {
      title: "Crear Contacto",
      drawer: false,
      isView: false,
      isEdit: false,
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view"
        },
        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "edit"
        }
      ],
      columns: [
        {
          prop: "FullName",
          name: "Nombre",
          fixed: true,
          minWidth: 200
        },
        {
          prop: "Email",
          name: "Correo",
          minWidth: 200
        },
        {
          prop: "PhoneNumber",
          name: "Tel.",
          minWidth: 150
        },
        {
          prop: "ExtensionNumber",
          name: "Ext.",
          width: 90
        },
        {
          prop: "MobilePhoneNumber",
          name: "Celular",
          minWidth: 150
        },
        {
          prop: "JobTitle",
          name: "Puesto",
          minWidth: 100
        },
        {
          prop: "Birthday",
          name: "Cumpleaño",
          width: 130,
          formatter: (row) => {
            return formatDate(row.Birthday, "DD-MM-YYYY");
          }
        },
        {
          prop: "LastDateModified",
          name: "Actualizacion",
          width: 130,
          formatter: (row) => {
            return formatDate(row.LastDateModified, "DD-MM-YYYY");
          }
        }
      ]
    };
  },
  computed: {
    params() {
      return {
        companyId: this.currentCompany
      };
    }
  },
  methods: {
    callNew() {
      this.isView = false;
      this.isEdit = false;
      this.drawer = true;
    },
    handlePushAction(command) {
      Object.assign(this.$refs.contact_form.model, command.row);

      switch (command.command) {
        case "view":
          this.isView = true;
          this.drawer = true;
          break;

        case "edit":
          this.isEdit = true;
          this.isView = false;
          this.drawer = true;
          break;

        case "delete":
          this.$confirm("Segura/o que desea eliminar este registro ?")
            .then(() => {
              this.$message.success("Contacto eliminado");
            })
            .catch(() => {
              this.$message.info("Eliminacion cancelada");
            });
          break;

        default:
          break;
      }
    }
  }
};
</script>

<style></style>
